import { useCallback, useEffect, useState } from "react";
import { EnumTypes, ENV_CONFIG } from "../../utils/constants";
import { Autocomplete, Box, Button, Container, TextField } from "@mui/material";
import { printExpiryReceipt } from "../../utils/commonHelpers";
import useStore from "../../store";
import { sortBy } from "lodash";
import { IExpiryTracking } from "../../types/IExpiryTracking";

const ExpiryTracking = () => {
  const [selectedExpiryConfigId, setSelectedExpiryConfigId] = useState<
    string | null
  >(null);
  console.log("selectedExpiryConfigId: ", selectedExpiryConfigId);
  const [expiryTrackingList, setExpiryTrackingList] = useState<
    IExpiryTracking[]
  >([]);
  console.log("expiryTrackingList: ", expiryTrackingList);

  const { enums } = useStore();

  const expiryConfigs = sortBy(enums[EnumTypes.EXPIRY_CONFIG] || [], ["title"]);
  const expiryConfigOptions = expiryConfigs.map((v) => ({
    id: v.id,
    label: `${v.title} (${v.shelf_life_in_days} days)`,
  }));
  console.log("expiryConfigOptions: ", expiryConfigOptions);

  const fetchAndSetExpiryTracking = useCallback(async () => {
    setExpiryTrackingList([]);

    const url = new URL(
      "/api/management/expiry-tracking/",
      ENV_CONFIG.BACKEND_BASE_URL,
    );

    const response = await fetch(url);
    const data = await response.json();

    setExpiryTrackingList(data.results);
  }, []);

  useEffect(() => {
    fetchAndSetExpiryTracking();
  }, [fetchAndSetExpiryTracking]);

  const handlePrintReceipt = () => {
    const selectedExpiryConfig = expiryConfigs.find(
      (v) => v.id === selectedExpiryConfigId,
    );
    if (selectedExpiryConfig) {
      printExpiryReceipt(selectedExpiryConfig);
    } else {
      console.log(`${selectedExpiryConfigId} not found in `, expiryConfigs);
    }
  };

  return (
    <Container id="expense-page-container">
      <Box flexDirection={"row"} display={"flex"} flex={1} gap={2}>
        <Autocomplete
          fullWidth
          filterOptions={(options, params) => {
            return options.filter((option) =>
              option.label
                .toLowerCase()
                .includes(params.inputValue.toLowerCase()),
            );
          }}
          value={expiryConfigOptions.find(
            (x) => x.id === selectedExpiryConfigId,
          )}
          options={expiryConfigOptions}
          renderInput={(params) => (
            <TextField {...params} placeholder="Choose item..." />
          )}
          onChange={(_, item) => setSelectedExpiryConfigId(item!.id)}
        />

        <Button variant="contained" onClick={handlePrintReceipt}>
          GENERATE
        </Button>
      </Box>
    </Container>
  );
};

export default ExpiryTracking;
